






























import Vue from "vue";
import { Component,  Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { AppConstants as _app } from "@/shared/app.constants";
import { Utilities as utils } from "@/shared/utilities";
import { ICommunicationData, ICommunication, ICommunicationReport, IChildStep, Feedback } from "@/entities";
import VJsonschemaForm from "@pan-gms/vuetify-jsonschema-form";
import { http as _http } from '@/shared/https';
import SectionContainer from './SectionContainer.vue';
import { Locales } from "@/i18n/locales";

const namespace: string = "communication";

@Component({
  components: {
      VJsonschemaForm,
      SectionContainer
  }
})
export default class CommunicationReportView extends Vue {

    @Prop() report!: ICommunicationReport;
    @Prop() template!: any;
    @Prop() selectedKey!: any;
    @Prop() editable!: boolean;
    @Prop() isDirty!: boolean;
    @Prop() doc!: string;
    @Prop() workflowInfo!: IChildStep;
    @Prop() userRoles: any;
    @State("feedback") feedback!: Feedback;
    @Action("uploadDocument", { namespace }) uploadDocument: any;
    @Action("getFeedbackInfo", { namespace: "feedback" }) getFeedbackInfo: any;
    @Action("createFeedbackHeader", { namespace: "feedback" }) createFeedbackHeader: any;
    @Action("getFeedbacks", { namespace: "feedback" }) getFeedbacks: any;
    @Action("resolve", { namespace: "feedback" }) resolveFeedback: any;
    @Action("reopen", { namespace: "feedback" }) reopenFeedback: any;
    @Action("showLoading", {namespace:"application"} ) showLoading: any;
    @Action("hideLoading", {namespace:"application"} ) hideLoading: any;
    @Action("updateReport", { namespace }) updateReport: any;
    @Action("openGuidelines", { namespace }) openGuidelines: any;
    @Action("submitReport", { namespace }) submitReport: any;
    @Action("returnReport", { namespace }) returnReport: any;
    @Action("reSubmitReport", { namespace }) reSubmitReport: any;
    @Getter("_appUser", { namespace: "RootApp" }) _username!: string;
    @Getter("_appUserId", { namespace: "RootApp" } ) _userid!: number;
    
    formValid: boolean = false;
    formKey: number = 1;
    defaultLocale: string = localStorage.getItem("language") || Locales.EN;

    get options() {
    return {
      //@ts-ignore
      disableAll: ((!this.workflowInfo.StepStatusId || ((!this.$can(this.actions.manage, this.subjects.communication)) && (this.workflowInfo.IsCompleted == 1)))) ,
      "uploadAction": this.uploadDocument,
      "openGuidelines": this.openGuideline,
      "removeAction": this.$services.document.deleteDocument,
      "updateDocAction": this.$services.document.updateMetadata,
      "downloadAction": this.$services.document.download,
      "locale": this.defaultLocale,
      "fileSizeLimit": this.appSettings.MaxFileSizeLimit,
      "maxFileLimit": this.appSettings.MaxFileLimit,
      "menu": _app.menu.communication,
      //@ts-ignore
      "rights": this.$can("manage", "feedback") ? _app.actions.manage : _app.actions.read,
      "entity": _app.entities.commReport,
      "httpLib": _http,
      "baseURI": process.env.VUE_APP_API_Base_URL,
      "feedbacks": this.feedback.feedbackHeaders,
      "transactionId": this.report.CommunicationReportId,
      "user": this._userid,
      "username": this._username,
      "actions": {
            createHeader: this.createFeedbackHeader,
            list: this.getFeedbacks,
            resolveFeedback: this.resolveFeedback,
            reopenFeedback: this.reopenFeedback,
            updateFeedback: this.$services.comment.Update
        },
        "loading": {
            show: this.showLoading,
            hide: this.hideLoading
        }
    }
  }

    get subSchema() {
        return this.template.properties[this.selectedKey];
    }

    feedbackInfo() {
        setTimeout(() => {
            this.getFeedbackInfo({ entity: _app.entities.commReport, transactionId: this.report.CommunicationReportId });
        }, 1000)
    }

    get actions() {
        return _app.actions;
    }

    get subjects() {
        return _app.subjects;
    }

    mounted() {
        this.loadFeedbackInfo();

        if(this.report.ReportData.threatList.length == 0)
        {
          this.report.ReportData.threatList.push({ "threat": {} });
        }
    }

    saveReport(x) {
        this.updateReport(this.report)
        .then(() => {
            this.formKey += 1;
        })
    }

    onReturned() {
        this.returnReport(this.report)
        .then((resp) => {
            this.$emit('setDirtyFalg', false);
        });
    }

     isAuditor() {
    if(this.userRoles == _app.appRoles.Auditor){
    return true;
    }
  }

    submitted() {
        if(this.workflowInfo.StepStatusId && ! this.workflowInfo.IsCompleted) {
            if(this.workflowInfo.IsReturned) {
                this.reSubmitReport(this.report)
                .then((resp) => {
                    this.$emit('setDirtyFalg', false);
                });

            } else {
                this.submitReport(this.report)
                .then((resp) => {
                    this.$emit('setDirtyFalg', false);
                });
            }
            
        }   
        
    }

    openGuideline() {
        this.openGuidelines(this.doc);
    }

    /** set the menu on menu change */
    setMenu(key) {
        if(this.isDirty) {
            this.updateReport(this.report)
            .then(() => {
                this.formKey += 1;
                this.$emit('menuChanged', key);
            })
        } else {
            this.$emit('menuChanged', key);
        }
        
    }

    loadFeedbackInfo() {
        const reportId = this.report.CommunicationReportId;
        this.getFeedbackInfo({ entity: _app.entities.commReport, transactionId: reportId });
    }


}

